import AdvanceConfirmPaymentScreen from 'features/advance/screens/advanceManualRepay/AdvanceConfirmPayment/AdvanceConfirmPaymentScreen';
import React from 'react';

const AdvanceConfirmPaymentPage = () => {
  return <AdvanceConfirmPaymentScreen />;
};

export default AdvanceConfirmPaymentPage;
